import React, { useState } from 'react';
import { Button } from '@mui/material';
import classnames from 'classnames/bind';
import Reveal from '../../ui/Reveal/Reveal';
import styles from './Waitlist.module.scss';

const cx = classnames.bind(styles);

type TFormStatus = 'idle' | 'sending' | 'success' | 'error';

const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
const WEB3FORMS_ACCESS_KEY = 'e781463a-04ab-4662-9e7c-f0e74b53f3d6';

export default function Waitlist() {
    const [status, setStatus] = useState<TFormStatus>('idle');

    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setStatus('sending');

        const formData = new FormData(event.currentTarget);
        formData.append('access_key', WEB3FORMS_ACCESS_KEY);
        formData.append('subject', 'New Shadowpilot waitlist signup');
        formData.append('from_name', 'Shadowpilot Landing');

        try {
            const response = await fetch(WEB3FORMS_ENDPOINT, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (response.ok && data.success) {
                setStatus('success');
            } else {
                console.error('Waitlist submission failed:', data.message);
                setStatus('error');
            }
        } catch (error) {
            console.error('Waitlist submission failed:', error);
            setStatus('error');
        }
    };

    return (
        <section className={cx('Section')} id='waitlist'>
            <div className={cx('Inner')}>
                <Reveal>
                    <p className={cx('Eyebrow')}>Early access</p>
                    <h2 className={cx('Title')}>
                        Be first <em>in the cockpit.</em>
                    </h2>
                    <p className={cx('Lead')}>
                        Shadowpilot is in active development. Join the waitlist and we&apos;ll
                        invite you as soon as the first seats open.
                    </p>

                    {status === 'success' ? (
                        <div className={cx('SuccessCard')}>
                            <p className={cx('SuccessTitle')}>You&apos;re on the list.</p>
                            <p className={cx('SuccessText')}>
                                We&apos;ll be in touch when your seat is ready.
                            </p>
                        </div>
                    ) : (
                        <form className={cx('Form')} onSubmit={onSubmit}>
                            <input
                                type='checkbox'
                                name='botcheck'
                                className={cx('Honeypot')}
                                tabIndex={-1}
                                autoComplete='off'
                            />
                            <input
                                type='text'
                                name='name'
                                placeholder='Your name'
                                required
                                autoComplete='name'
                                className={cx('Input')}
                            />
                            <input
                                type='email'
                                name='email'
                                placeholder='you@example.com'
                                required
                                autoComplete='email'
                                className={cx('Input')}
                            />
                            <Button
                                type='submit'
                                variant='contained'
                                color='primary'
                                size='large'
                                disabled={status === 'sending'}
                                className={cx('SubmitButton')}
                            >
                                {status === 'sending' ? 'Joining…' : 'Join the waitlist'}
                            </Button>

                            {status === 'error' && (
                                <p className={cx('ErrorText')} role='alert'>
                                    Something went wrong. Please try again.
                                </p>
                            )}
                        </form>
                    )}

                    <p className={cx('Microcopy')}>No spam. One email when it&apos;s your turn.</p>
                </Reveal>
            </div>
        </section>
    );
}
